import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Spin,
  Switch,
  message,
} from "antd";
import { getMercadoPago, upsertMercadoPago } from "./api";
import { MercadoPagoConfig } from "./types";

interface Props {
  sellerCode: string;
}

export const MercadoPagoCard: React.FC<Props> = ({ sellerCode }) => {
  const [form] = Form.useForm<MercadoPagoConfig>();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const data = await getMercadoPago(sellerCode);
      form.setFieldsValue(data);
    } catch {
      message.error("No se pudo cargar Mercado Pago");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (sellerCode) load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sellerCode]);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      setSaving(true);
      await upsertMercadoPago(sellerCode, values);
      message.success("Mercado Pago guardado");
    } catch (err: any) {
      const msg = err?.response?.data?.message || err?.message || "Error al guardar";
      message.error(Array.isArray(msg) ? msg.join(" • ") : msg);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card
      title="Mercado Pago"
      extra={
        <Button type="primary" loading={saving} onClick={handleSave}>
          Guardar
        </Button>
      }
      style={{ marginBottom: 16 }}
    >
      <Spin spinning={loading}>
        <Form form={form} layout="vertical">
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item label="Habilitado" name="enabled" valuePropName="checked">
                <Switch />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="Usar Checkout API (Bricks)" name="useCheckoutApi" valuePropName="checked">
                <Switch />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Título (opcional)" name="title">
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item label="Descripción (opcional)" name="description">
            <Input />
          </Form.Item>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Public Key" name="publicKey">
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Access Token" name="accessToken">
                <Input.Password placeholder="••••••••" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Monto máximo sin verificación"
                name="maxAmountWithoutVerification"
              >
                <InputNumber min={0} style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Spin>
    </Card>
  );
};
